export const snackbar = {
  namespaced: true,
  state: {
    icon: '',
    content: '',
    snackbarColor: '',
    snackbarBtnColor: ''
  },
  mutations: {
    showMessage(state, payload) {
      state.icon = payload.icon
      state.content = payload.content
      state.snackbarColor = payload.snackbarColor
      state.snackbarBtnColor = payload.snackbarBtnColor
    }
  }
}
